import { render, staticRenderFns } from "./TheConfigurationJsonEditor.vue?vue&type=template&id=5df6a5d8&scoped=true&"
import script from "./TheConfigurationJsonEditor.vue?vue&type=script&lang=js&"
export * from "./TheConfigurationJsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./TheConfigurationJsonEditor.vue?vue&type=style&index=0&id=5df6a5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df6a5d8",
  null
  
)

export default component.exports